<template>
  <div class="jersey-box">
    <div class="jersey-size">
      <div class="label">球衣尺码</div>
      <div class="card" v-if="card" @click="show = true">查看尺码表</div>
      <div class="input" @click="showList = true">
        <div v-if="!input" class="po">请选择球衣尺码</div>
        <div v-else class="nnn">{{ input }}</div>
      </div>
    </div>
    <van-overlay :show="show" @click="show = false">
      <img :src="imgView(card)" class="card-img" />
    </van-overlay>
    <van-popup v-model="showList" position="bottom">
      <van-picker title="球衣尺码" show-toolbar :columns="arr" @cancel="showList = false" @confirm="confirm" />
    </van-popup>
  </div>
</template>

<script>
import { QNImageUtil } from '@/utils'
import Vue from 'vue';
import { Overlay, Popup, Picker } from 'vant';
Vue.use(Overlay).use(Popup).use(Picker);
export default {
  props: {
    card: {
      type: String,
      default: ''
    },
    arr: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ''
    }
  },
  watch: {
    text: {
      handler(e) {
        this.input = e
      },
      immediate: true
    }
  },
  mounted() {
    
  },
  data() {
    return {
      input: '',
      show: false,
      showList: false,
    };
  },
  methods: {
    imgView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    confirm(value) {
      this.input = value
      this.$emit('update', value)
      this.showList = false
    }
  },
};
</script>

<style scoped lang="scss">
.jersey-box {
  padding: 0 16px;
  background-color: #fff;
}

.jersey-size {
  padding: 10px 0;
  color: #323233;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.5px #EEEEEE solid;

  .label {
    width: 80px;
  }

  .card {
    background-color: #9a9a9a;
    color: #fff;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 12px;
  }

  .input {
    flex: 1;
    text-align: right;

    .po {
      color: #CACACD;
    }

    .nnn {}
  }
}

::v-deep .van-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-img {
  width: 80%;
}
</style>
